/**
 * 全店舗一括設定 バリデーションルール
 */
export default {
  shop: 'numeric|between:0,99',
  table: 'numeric|between:0,99',
  pre: 'numeric|between:0,99',
  smartOrder: 'required|numeric|between:0,1',
  priceDisplay: 'required|numeric|between:0,1',
  bikkuraponRateChange: 'required|numeric|between:0,1',
  bikkuraponIconDisplay: 'required|numeric|between:0,1',
}
